export default __webpack_public_path__ + "static/media/play.81516a4a.svg";